import React from 'react'
import AuthWrapper from './AuthWrapper'
import notap_logo from '../../assets/images/notap_logo.png';

export default function AuthFormWrapper({children, sub_text, onHandleSubmit, icon, iconColor}) {
  return (
    <AuthWrapper>
      <div className='card card-default p-5'>
        <div className='formContainer'>
            <div style={{columnGap: '1rem'}} className='d-flex align-items-center justify-content-center'>
              <img src={notap_logo} alt='logo' className='logotypeImage' />
              <h2 className='font-weight-bold'>
                NOTAP Portal
              </h2>              
            </div>
            <div style={{columnGap: '0.8rem'}} className='greeting d-flex justify-content-center align-items-center'>
              {icon && <i style={{fontSize: '1.5rem'}} className={`${iconColor ?? '' } ${icon}`}></i>}
              <p style={{fontSize: '1.3rem'}} className={`${iconColor ?? '' } text-capitalize`}>
                {sub_text}
              </p>
            </div>
            <form className='mainForm' onSubmit={onHandleSubmit}>
              <div className="row w-100 m-0">
                {children}
              </div>
            </form>
        </div>        
      </div>
    </AuthWrapper>
  )
}
